import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { InquiryLabelsFormValues } from 'src/models/InquiryLabels.model';
import InquiryLabelsForm from '../Layouts/InquiryLabelsForm';
import { useEditInquiryLabelMutation, useSingleEditDataQuery } from 'src/services/InquiryLabelServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
    onClose: () => void;
    id: any
};

const EditInquiryLabelsFormWrapper = ({ onClose, id }: Props) => {
    const [editInquiryLabel] = useEditInquiryLabelMutation()
    const { data } = useSingleEditDataQuery(id)


    // Form Initial Values
    const initialValues: InquiryLabelsFormValues = {
        inquiryLabel: data?.data?.inquiryLabel || ""
    };

    // Validation Schema
    const validationSchema = object().shape({
        inquiryLabel: string().required('Please enter name'),
    });

    // Handle Submit
    const handleSubmit = (
        values: InquiryLabelsFormValues,
        { setSubmitting, resetForm }: FormikHelpers<InquiryLabelsFormValues>
    ) => {
        editInquiryLabel({ id: id, body: values }).then((res: any) => {
            if (res?.error) {
                showToast('error', res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast('success', res?.data?.message);
                    resetForm();
                    onClose();
                } else {
                    showToast('error', res?.data?.message);
                }
            }
            setSubmitting(false);
        })
    };

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <InquiryLabelsForm formikProps={formikProps} onClose={onClose} formType='EDIT' />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default EditInquiryLabelsFormWrapper;